// jaride-412615, as shipped in production OTA 2026-08-21.
export const FirebaseConfig = {
	"projectId": "jaride-412615",
	"appId": "1:48464566007:web:ba51c06264c22353a465f2",
	"databaseURL": "https://jaride-412615-default-rtdb.firebaseio.com",
	"storageBucket": "jaride-412615.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyAk4UsytAMFtpOKN3-vmePdzdZRWGvSZds",
	"authDomain": "jaride-412615.firebaseapp.com",
	"messagingSenderId": "48464566007",
	"measurementId": "G-G81T1H1Q0X",
	"projectNumber": "48464566007",
	"version": "2"
};
